import { render, staticRenderFns } from "./RecommendedModulesWarning.vue?vue&type=template&id=05cf7289"
import script from "./RecommendedModulesWarning.vue?vue&type=script&lang=js"
export * from "./RecommendedModulesWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports